module.exports = __webpack_public_path__ + "media/assets/partners/itrue-9b37c317e9b2e05d55bd4fff047d5df2.svg";